<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}




  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"App marketing",
    "pageDesc":"Increase your App visibility and ranking on store with app store optimization, ",
    "mantra":"App marketing for |every store.",
    "sec1Items":{
      "1":{
        "title":"Increase store discoverability",
        "desc":"Reach your target audience in store by capitalizing on the keywords, description and imagery of the app."
      },
      "2":{
        "title":"Spread awareness",
        "desc":"We help you gain popularity and generate word of mouth about your application through marketing campaigns on different channels."
      },
      "3":{
        "title":"Improve conversion",
        "desc":"Attracting more relevant audience through campaigns and store optimization practices. "
      }
    },
    "sec2":"Improve your App visibility.",
    "sec2Items":{
      "1":{
        "title":"App landing page",
        "desc":"Designing and optimizing a landing page for your app to different traffic from google and boost your downloads rate."
      },
      "2":{
        "title":"ASO audit",
        "desc":"Conducting an ASO analysis for your app and planning for better visibility for your app through organic ASO growth methods."
      },
      "3":{
        "title":"Content optimization",
        "desc":"Conducting keyword research and creating description, titles and walk through images that are targeted to the app features."
      }
    },

    "cta":"Get your app <br> ranked "
  },
  "ar": {
    "pageTitle":"تسويق التطبيقات",
    "pageDesc":"زود من معدل ظهور تطبيقاتك للمستخدمين الذين تستهدفهم وتحسين ترتيب متجرك من خلال تحسين متجر التطبيقات.",
    "mantra":"تسويق التطبيقات |لمختلف المتاجر.",
    "sec1Items":{
      "1":{
        "title":"زيادة ظهور التطبيقات",
        "desc":"يمكنك الوصول إلى جمهورك المستهدف من خلال الاستفادة من الكلمات الرئيسية والوصف وصور التطبيق."
      },
      "2":{
        "title":"زيادة الوعى",
        "desc":"نساعدك على اكتساب شعبية كبيرة لتطبيقك وإنشاء قاعدة كبيرة من المستخدمين من خلال التسويق الشفهي حول تطبيقك من خلال الحملات التسويقية على القنوات المختلفة."
      },
      "3":{
        "title":"زيادة عمليات التحويل",
        "desc":"اجذب المزيد من المستخدمين تجاه تطبيقك من خلال الحملات المستهدفة."
      }
    },
    "sec2":"حسّن من معدل ظهور تطبيقك في المتجر.",
    "sec2Items":{
      "1":{
        "title":"صفحة الهبوط للتطبيق",
        "desc":"يمكنك تصميم وتحسين صفحة الهبوط  للتطبيق الخاص بك للمزيد من حركة الزوار المختلفة القادمة من جوجل واعمل على زيادة معدل التحميلات."
      },
      "2":{
        "title":"تدقيق ASO",
        "desc":"نعمل على إجراء تحليل ASO للتطبيق الخاص بك والتخطيط للتحسين من معدل ظهور التطبيق الخاص بك من خلال أساليب النمو الطبيعية ASO."
      },
      "3":{
        "title":"تحسين المحتوى",
        "desc":"نقوم بإجراء الأبحاث حول الكلمات الرئيسية وإنشاء الوصف والعناوين واختيار الصور المناسبة التي تعبر عن مميزات التطبيق."
      }
    },

    "cta":"احصل على الترتيب <br> المناسب لتطبيقك. "
  }
}
</i18n>
